import { createApp } from "vue";
import App from "./App.vue";

import "./assets/fonts/fonts.css"; // Importa el archivo de fuentes
import { router } from "./router/index.js"; // Importa el archivo de rutas

const app = createApp(App);
app.use(router);
app.mount("#app");
